(() => {
  window['dataLayer'] = window['dataLayer'] || []
  window['dataLayer'].push({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
  })

  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
    'wait_for_update': 1000,
  })

  new Promise(resolve => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve)
    } else {
      resolve()
    }
  }).then(consent)

  function has () {
    if (!window.Shopify) {
      return false
    }

    const cookies = Object.fromEntries(document.cookie.split('; ')
      .map(v => v.split(/=(.*)/s)
      .map(decodeURIComponent)))

    if (typeof window?.Shopify?.customerPrivacy?.userCanBeTracked === 'function') {
      return window.Shopify.customerPrivacy.userCanBeTracked()
    } else if (cookies._tracking_consent) {
      const consentCookie = JSON.parse(cookies._tracking_consent)
      let consentStatus = typeof consentCookie['con']['GDPR'] !== 'undefined'
        ? consentCookie['con']['GDPR']
        : consentCookie['con']['CMP']['m']

      if (consentStatus === 1 || consentStatus === '1') {
        return true
      }
    }

    return false
  }

  function consent () {
    if (has()) {
      gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted'
      })

      return
    }

    setTimeout(consent, 1000)
  }

  load()

  function gtag () {
    window['dataLayer'].push(arguments)
  }

  function load () {
    const domScript = document.getElementsByTagName('script')[0]
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MDT9VZ6X'
    domScript.parentNode.insertBefore(script, domScript)
  }
})()
